var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringSkipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skippeda)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skippedb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    d: "M12 5.44a.487.487 0 0 0-.14-.333l-.96-.967a.48.48 0 0 0-.82.333v.404a.083.083 0 0 1-.083.083H8.8a1.763 1.763 0 0 0-1.76 1.76v3.52a.803.803 0 0 1-.8.8H4.48a.48.48 0 0 0 0 .96h1.76A1.763 1.763 0 0 0 8 10.24V6.72a.803.803 0 0 1 .8-.8H10a.083.083 0 0 1 .083.083V6.4a.48.48 0 0 0 .48.48.493.493 0 0 0 .334-.14l.96-.96A.487.487 0 0 0 12 5.44Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "skippeda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "skippedb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h8v8H4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringSkipped);
export default __webpack_public_path__ + "static/media/recurring-skipped.6365c3ee5accfbdf7d2f1d3da059265d.svg";
export { ForwardRef as ReactComponent };